import { useContext, useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import { Button } from "../components/ui/button";
import { Card, CardContent } from "../components/ui/card";

import "../singapore.css";
import ScrolltoTop from "./ScrolltoTop";
import Footer from "./Footer";
import Navbar from "./navbar";
import Int2specialform from "./Int2specialform";
import UTMHandler from "./UTMHandler";
import { CurrencyContext } from "./CurrencyContext";
import AutoShowModal from "./AutoShowModal";


const CIcon = {
  USD: '$' ,
  INR:  '₹' ,
  SGD:  'S$' 
};

const itineraryData = [
  { day: "Day 1", port: "SINGAPORE - SINGAPORE", arrive: "", depart: "16:30:00", activity: "EMBARK" },
  { day: "Day 2", port: "PENANG - MALAYSIA", arrive: "15:00:00", depart: "23:00:00", activity: "DOCKED" },
  { day: "Day 3", port: "CRUISING", arrive: "", depart: "", activity: "CRUISING" },
  { day: "Day 4", port: "SINGAPORE - SINGAPORE", arrive: "07:00:00", depart: "", activity: "DEBARK" },
];

const pricingData = {
  USD:[
  { sailingDate: "20-OCT-2025", cruiseFare: "$413", nccf: "$80", tax: "$52", gratuities: "$56", totalCabinFare: "$1202" },
  { sailingDate: "27-OCT-2025", cruiseFare: "$374", nccf: "$80", tax: "$50", gratuities: "$56", totalCabinFare: "$1120" },
  { sailingDate: "17-NOV-2025", cruiseFare: "$374", nccf: "$80", tax: "$63", gratuities: "$56", totalCabinFare: "$1145" },
  { sailingDate: "24-NOV-2025", cruiseFare: "$486", nccf: "$80", tax: "$63", gratuities: "$56", totalCabinFare: "$1369" },
  { sailingDate: "15-DEC-2025", cruiseFare: "$536", nccf: "$80", tax: "$62", gratuities: "$56", totalCabinFare: "$1468" },
  { sailingDate: "18-DEC-2025", cruiseFare: "$570", nccf: "$80", tax: "$62", gratuities: "$56", totalCabinFare: "$1535" },
  { sailingDate: "21-DEC-2025", cruiseFare: "$648", nccf: "$80", tax: "$62", gratuities: "$56", totalCabinFare: "$1692" },
  { sailingDate: "05-JAN-2026", cruiseFare: "$368", nccf: "$80", tax: "$49", gratuities: "$56", totalCabinFare: "$1106" },
  { sailingDate: "16-JAN-2026", cruiseFare: "$413", nccf: "$80", tax: "$49", gratuities: "$56", totalCabinFare: "$1196" },
  { sailingDate: "19-JAN-2026", cruiseFare: "$368", nccf: "$80", tax: "$49", gratuities: "$56", totalCabinFare: "$1106" },
  { sailingDate: "26-JAN-2026", cruiseFare: "$368", nccf: "$80", tax: "$49", gratuities: "$56", totalCabinFare: "$1106" },
  { sailingDate: "02-FEB-2026", cruiseFare: "$368", nccf: "$80", tax: "$50", gratuities: "$56", totalCabinFare: "$1109" },
  { sailingDate: "09-FEB-2026", cruiseFare: "$380", nccf: "$80", tax: "$50", gratuities: "$56", totalCabinFare: "$1131" },
  { sailingDate: "12-FEB-2026", cruiseFare: "$413", nccf: "$80", tax: "$50", gratuities: "$56", totalCabinFare: "$1198" },
  { sailingDate: "15-FEB-2026", cruiseFare: "$581", nccf: "$80", tax: "$50", gratuities: "$56", totalCabinFare: "$1533" },
  { sailingDate: "03-MAR-2026", cruiseFare: "$380", nccf: "$80", tax: "$50", gratuities: "$56", totalCabinFare: "$1131" },
  { sailingDate: "06-MAR-2026", cruiseFare: "$413", nccf: "$80", tax: "$50", gratuities: "$56", totalCabinFare: "$1198" }
  ],
  SGD:[
  { sailingDate: "20-OCT-2025", cruiseFare: "S$514", nccf: "S$100", tax: "S$66", gratuities: "S$75", totalCabinFare: "S$1510" },
  { sailingDate: "27-OCT-2025", cruiseFare: "S$465", nccf: "S$100", tax: "S$63", gratuities: "S$75", totalCabinFare: "S$1407" },
  { sailingDate: "17-NOV-2025", cruiseFare: "S$465", nccf: "S$100", tax: "S$79", gratuities: "S$75", totalCabinFare: "S$1438" },
  { sailingDate: "24-NOV-2025", cruiseFare: "S$605", nccf: "S$100", tax: "S$79", gratuities: "S$75", totalCabinFare: "S$1718" },
  { sailingDate: "15-DEC-2025", cruiseFare: "S$668", nccf: "S$100", tax: "S$77", gratuities: "S$75", totalCabinFare: "S$1842" },
  { sailingDate: "18-DEC-2025", cruiseFare: "S$710", nccf: "S$100", tax: "S$77", gratuities: "S$75", totalCabinFare: "S$1925" },
  { sailingDate: "21-DEC-2025", cruiseFare: "S$808", nccf: "S$100", tax: "S$78", gratuities: "S$75", totalCabinFare: "S$2123" },
  { sailingDate: "05-JAN-2026", cruiseFare: "S$458", nccf: "S$100", tax: "S$61", gratuities: "S$75", totalCabinFare: "S$1389" },
  { sailingDate: "16-JAN-2026", cruiseFare: "S$514", nccf: "S$100", tax: "S$62", gratuities: "S$75", totalCabinFare: "S$1502" },
  { sailingDate: "19-JAN-2026", cruiseFare: "S$458", nccf: "S$100", tax: "S$61", gratuities: "S$75", totalCabinFare: "S$1389" },
  { sailingDate: "26-JAN-2026", cruiseFare: "S$458", nccf: "S$100", tax: "S$61", gratuities: "S$75", totalCabinFare: "S$1389" },
  { sailingDate: "02-FEB-2026", cruiseFare: "S$458", nccf: "S$100", tax: "S$63", gratuities: "S$75", totalCabinFare: "S$1393" },
  { sailingDate: "09-FEB-2026", cruiseFare: "S$472", nccf: "S$100", tax: "S$63", gratuities: "S$75", totalCabinFare: "S$1421" },
  { sailingDate: "12-FEB-2026", cruiseFare: "S$514", nccf: "S$100", tax: "S$63", gratuities: "S$75", totalCabinFare: "S$1505" },
  { sailingDate: "15-FEB-2026", cruiseFare: "S$724", nccf: "S$100", tax: "S$62", gratuities: "S$75", totalCabinFare: "S$1923" },
  { sailingDate: "03-MAR-2026", cruiseFare: "S$472", nccf: "S$100", tax: "S$63", gratuities: "S$75", totalCabinFare: "S$1421" },
  { sailingDate: "06-MAR-2026", cruiseFare: "S$514", nccf: "S$100", tax: "S$63", gratuities: "S$75", totalCabinFare: "S$1505" }
  ]
  ,
  INR:[
  { sailingDate: "20-OCT-2025", cruiseFare: "₹34,232", nccf: "₹6,660", tax: "₹4,367", gratuities: "₹5,027", totalCabinFare: "₹1,00,573" },
  { sailingDate: "27-OCT-2025", cruiseFare: "₹30,969", nccf: "₹6,660", tax: "₹4,196", gratuities: "₹5,027", totalCabinFare: "₹93,704" },
  { sailingDate: "17-NOV-2025", cruiseFare: "₹30,969", nccf: "₹6,660", tax: "₹5,242", gratuities: "₹5,027", totalCabinFare: "₹95,796" },
  { sailingDate: "24-NOV-2025", cruiseFare: "₹40,293", nccf: "₹6,660", tax: "₹5,242", gratuities: "₹5,027", totalCabinFare: "₹1,14,444" },
  { sailingDate: "15-DEC-2025", cruiseFare: "₹44,489", nccf: "₹6,660", tax: "₹5,152", gratuities: "₹5,027", totalCabinFare: "₹1,22,655" },
  { sailingDate: "18-DEC-2025", cruiseFare: "₹47,286", nccf: "₹6,660", tax: "₹5,146", gratuities: "₹5,027", totalCabinFare: "₹1,28,237" },
  { sailingDate: "21-DEC-2025", cruiseFare: "₹53,813", nccf: "₹6,660", tax: "₹5,183", gratuities: "₹5,027", totalCabinFare: "₹1,41,366" },
  { sailingDate: "05-JAN-2026", cruiseFare: "₹30,503", nccf: "₹6,660", tax: "₹4,069", gratuities: "₹5,027", totalCabinFare: "₹92,517" },
  { sailingDate: "16-JAN-2026", cruiseFare: "₹34,232", nccf: "₹6,660", tax: "₹4,100", gratuities: "₹5,027", totalCabinFare: "₹1,00,039" },
  { sailingDate: "19-JAN-2026", cruiseFare: "₹30,503", nccf: "₹6,660", tax: "₹4,069", gratuities: "₹5,027", totalCabinFare: "₹92,517" },
  { sailingDate: "26-JAN-2026", cruiseFare: "₹30,503", nccf: "₹6,660", tax: "₹4,069", gratuities: "₹5,027", totalCabinFare: "₹92,517" },
  { sailingDate: "02-FEB-2026", cruiseFare: "₹30,503", nccf: "₹6,660", tax: "₹4,201", gratuities: "₹5,027", totalCabinFare: "₹92,782" },
  { sailingDate: "09-FEB-2026", cruiseFare: "₹31,435", nccf: "₹6,660", tax: "₹4,201", gratuities: "₹5,027", totalCabinFare: "₹94,647" },
  { sailingDate: "12-FEB-2026", cruiseFare: "₹34,232", nccf: "₹6,660", tax: "₹4,183", gratuities: "₹5,027", totalCabinFare: "₹1,00,205" },
  { sailingDate: "15-FEB-2026", cruiseFare: "₹48,218", nccf: "₹6,660", tax: "₹4,138", gratuities: "₹5,027", totalCabinFare: "₹1,28,086" },
  { sailingDate: "03-MAR-2026", cruiseFare: "₹31,435", nccf: "₹6,660", tax: "₹4,196", gratuities: "₹5,027", totalCabinFare: "₹94,636" },
  { sailingDate: "06-MAR-2026", cruiseFare: "₹34,232", nccf: "₹6,660", tax: "₹4,196", gratuities: "₹5,027", totalCabinFare: "₹1,00,230" }
  ]
};

export default function CruiseBooking() {

const currency = useContext(CurrencyContext);

  const [expandedDays, setExpandedDays] = useState({});
  const [expandedPricing, setExpandedPricing] = useState({});

  const toggleDay = (day) => {
    setExpandedDays(prev => ({ ...prev, [day]: !prev[day] }));
  };

  const togglePricing = (date) => {
    setExpandedPricing(prev => ({ ...prev, [date]: !prev[date] }));
  };

  return (
    <>

    <UTMHandler/>
   
   <div className="about-navbar">
        <Navbar/>
</div>


   
    <div className="cruise-container mobile-cruise-container">
      <div className="cruise-header mobile-cruise-header">
        <h1>Int2Cruises Special Offer</h1>
        <h4>Onboard</h4>
        <h3>Royal Caribbean's - Ovation of the Seas</h3>
        <h2>3 NIGHT PENANG CRUISE</h2>
        {/* <p className="destinations">Singapore • Malaysia • Singapore</p> */}
        
      </div>

      <div className="itinerary-desktop">
        <table>
          <thead>
            <tr>
              <th>Day</th><th>Port</th><th>Arrive</th><th>Depart</th><th>Activity</th>
            </tr>
          </thead>
          <tbody>
            {itineraryData.map((item, i) => (
              <tr key={i} className={i % 2 === 0 ? "even" : "odd"}>
                <td>{item.day}</td><td>{item.port}</td><td>{item.arrive}</td><td>{item.depart}</td><td>{item.activity}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="itinerary-mobile">
        {itineraryData.map((item, i) => (
          <Card key={i} className="mobile-card">
            <div className="card-header" onClick={() => toggleDay(item.day)}>
              <span>{item.day} {item.port}</span>
              {expandedDays[item.day] ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
            </div>
            {expandedDays[item.day] && (
              <CardContent className="card-content">
                <div><strong>Port:</strong> {item.port}</div>
                <div><strong>Arrive:</strong> {item.arrive || ''}</div>
                <div><strong>Depart:</strong> {item.depart || ''}</div>
                <div><strong>Activity:</strong> {item.activity}</div>
              </CardContent>
            )}
          </Card>
        ))}
      </div>

      <div className="pricing-header">
        <h3>4D - Oceanview Balcony<br />( All inclusive Fare at Double Occupancy )</h3>
       <center ><p style={{marginTop:'-4vh',fontSize:'1.6rem',fontWeight:'700', color:'#72c9c5'}}>IN {currency.currencyCode}({CIcon[currency.currencyCode]})</p></center>
      
      </div>

      <div className="pricing-desktop">
        <table>
          <thead>
            <tr>
              <th>Sailing Date</th><th>Cruise Fare<br /><span>(per person)</span></th>
              <th>NCCF<br /><span>(per person)</span></th><th>Tax<br /><span>(per person)</span></th>
              <th>Gratuities<br /><span>(per person)</span></th><th>Total Cabin Fare</th><th>Action</th>
            </tr>
          </thead>
          <tbody>
            {pricingData[currency.currencyCode].map((item, i) => (
              <tr key={i} className={i % 2 === 0 ? "even" : "odd"}>
                <td>{item.sailingDate}</td><td>{item.cruiseFare}</td><td>{item.nccf}</td>
                <td>{item.tax}</td><td>{item.gratuities}</td><td>{item.totalCabinFare}</td>
                <td>      <Button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#staticBackdrop">Book Now</Button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="pricing-mobile">
        {pricingData[currency.currencyCode].map((item, i) => (
          <Card key={i} className="mobile-card">
            <div className="card-header" onClick={() => togglePricing(`${item.sailingDate}-${i}`)}>
              <div>
                <div>Sailing Date</div>
                <div>{item.sailingDate}</div>
              </div>
              <div>
                <div>Total Cabin Fare</div>
                <div>{item.totalCabinFare}</div>
              </div>
              {expandedPricing[`${item.sailingDate}-${i}`] ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
            </div>
            {expandedPricing[`${item.sailingDate}-${i}`] && (
              <CardContent className="card-content">
                <div><strong>Cruise Fare:</strong> {item.cruiseFare} <span>(per person)</span></div>
                <div><strong>NCCF:</strong> {item.nccf} <span>(per person)</span></div>
                <div><strong>Tax:</strong> {item.tax} <span>(per person)</span></div>
                <div><strong>Gratuities:</strong> {item.gratuities} <span>(per person)</span></div>
                      <Button type="button" class="btn btn-primary " data-bs-toggle="modal" data-bs-target="#staticBackdrop">Book Now</Button>
              </CardContent>
            )}
          </Card>
        ))}
      </div>



<div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <Int2specialform leadsource="3Night-Singapore"/>
      </div>
      {/* <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary">Understood</button>
      </div> */}
    </div>
  </div>
</div>

    </div>

    <ScrolltoTop/>
    <AutoShowModal/>
    <Footer/>

     </>
  );
}
